import { AttachmentPreview } from 'components/attachmentPreview/attachmentPreview.module';
import { ChatSettings } from 'components/chatSettings/chatSettings.module';
import { ChatHeader } from 'components/header/types/chatHeader/chatHeader.module';
import LaunchHeader from 'components/header/types/launchHeader/launchHeader.module';
import SourceViewer from 'components/sourceViewer/sourceViewer.module';
import { BOT_MODE } from 'consts/enum';
import { setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import ChatScreen from 'screen/chatScreen/chatScreen.module';
import LaunchScreen from 'screen/launchScreen/launchScreen.module';

import { PopupComponent } from './popup.component';
import { popupModel } from './popup.model';

export class Popup {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEvents();
		this.initHelpers();
		this.onMount();
	}

	initData(props) {
		this.data = popupModel;
		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-popup');
		if (ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET) {
			wrapper.classList.add('engt-popup-hidden');
			wrapper.classList.add('engt-popup-hidden-size');
		}
		wrapper.id = 'engt-popup';
		wrapper.innerHTML = PopupComponent.render(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const chatScreen = new ChatScreen().render();
		const launchScreen = new LaunchScreen().render();
		const chatSettings = new ChatSettings().render();
		const chatHeader = new ChatHeader().render();
		const launchHeader = new LaunchHeader().render();
		const attachmentPreview = new AttachmentPreview().render();
		const header = document.createElement('div');

		header.classList.add('engt-common-header');
		header.appendChild(chatHeader);
		header.appendChild(launchHeader);

		setCustomTagHTML(this.html.querySelector('engt-header'), header);
		setCustomTagHTML(this.html.querySelector('launch-screen'), launchScreen);
		setCustomTagHTML(this.html.querySelector('chat-screen'), chatScreen);
		setCustomTagHTML(this.html.querySelector('chat-settings'), chatSettings);
		setCustomTagHTML(this.html.querySelector('upload-file-attachment'), attachmentPreview);

		const isSourcePreviewEnabled =
			ENGT_CHAT.get('config.isWebLinkPreviewEnabled') || ENGT_CHAT.get('config.isPdfLinkPreviewEnabled');
		if (isSourcePreviewEnabled) {
			const sourcePreview = new SourceViewer().render();
			setCustomTagHTML(this.html.querySelector('source-preview'), sourcePreview);
		}
	}

	initEvents() {
		this.html.addEventListener('click', ENGT_CHAT.get('menuClose'));
	}

	initHelpers() {
		const onMaximizeScreen = (shouldMinimize = false) => {
			if (ENGT_CHAT.get('isMobileOrTablet')) {
				return;
			}
			if (shouldMinimize || this.html.classList.contains('engt-maximise-screen')) {
				this.html.classList.add('engt-minimise-screen');
				this.html.classList.remove('engt-maximise-screen');
			} else {
				this.html.classList.add('engt-maximise-screen');
				this.html.classList.remove('engt-minimise-screen');
			}
		};

		ENGT_CHAT.set('onMaximizeScreen', onMaximizeScreen.bind(this));
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	onMount() {
		PopupComponent.init();
	}

	render() {
		return this.html;
	}
}
